import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Input, message, Modal, Row } from "antd";

import { functionsService } from "./../../redux/services";

import {
	UIDrawerForm,
	UIFormSection,
} from "./../../components";

import { FunctionsInfoBanner, FunctionStatusField } from "./create";

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`;

class Edit extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			isSending: false,
			uuid: 0,
		};
	}

	onOpen = (uuid) => {
		this.setState({
			isLoading: true,
			uuid: uuid,
		});

		functionsService.show({ uuid })
			.then((response) => {
				const item = response.data.data;

				this.setState({
					isLoading: false,
				}, () => {
					// Fill form
					this.fillForm(item);
				});
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
					onOk: () => {
						// Force close
						return this.onClose();
					}
				});
			});
	};

	fillForm = (data) => {
		this.form.setFieldsValue({
			nome: data.nome,
			ativo: data.ativo == 1,
		});
	};

	onClose = () => {
		// Callback
		this.props.onClose();
	};

	onFinish = (values) => {
		this.setState({
			isSending: true,
		});

		const data = {
			...values,
			uuid: this.state.uuid,
		};

		functionsService.edit(data)
			.then((response) => {
				this.setState({
					isSending: false,
				});

				// Success message
				message.success("Registro atualizado com sucesso.");

				// Callback
				this.props.onComplete();
			})
			.catch((data) => {
				this.setState({
					isSending: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	render() {
		const { visible } = this.props;

		const { isLoading, isSending } = this.state;

		return (
			<UIDrawerForm
				visible={visible}
				width={700}
				onClose={this.onClose}
				isLoading={isLoading}
				isSending={isSending}
				formId={formId}
				icon={<i className="fal fa-user-tie" />}
				title="Editar função"
				subtitle="Atualize as informações da função/cargo.">
				<Form
					ref={el => this.form = el}
					id={formId}
					layout="vertical"
					scrollToFirstError
					onFinish={this.onFinish}>
					<UIFormSection
						icon={<i className="fal fa-clipboard-list" />}
						title="Informações gerais"
						description="Dados de identificação da função.">
						<Row gutter={16}>
							<Col xs={24}>
								<Form.Item
									name="nome"
									label="Nome da função"
									extra="Informe o nome que identifica esta função/cargo na empresa."
									hasFeedback
									rules={[{ required: true, message: "Campo obrigatório." }]}>
									<Input placeholder="Digite o nome da função" />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<FunctionStatusField />
							</Col>
						</Row>
					</UIFormSection>
					<FunctionsInfoBanner />
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Edit;
